import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="12" height="12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M10.5 6.75H6.75v3.75c0 .412-.338.75-.75.75a.752.752 0 01-.75-.75V6.75H1.5A.752.752 0 01.75 6c0-.412.337-.75.75-.75h3.75V1.5c0-.413.338-.75.75-.75s.75.337.75.75v3.75h3.75c.412 0 .75.338.75.75s-.338.75-.75.75z" fill="#07A" /></svg>;